import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Gst } from 'src/app/model/gst.model';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-evalvendregistation',
  templateUrl: './evalvendregistation.component.html',
  styleUrls: ['./evalvendregistation.component.css']
})
export class EvalvendregistationComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;

  stepno: string;
  applicationref: string;
  returnData: any;

  vendorDocs: any;

  tiers: Gst[] = [];
  readonly rootUrl = environment.baseUrl;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService,
    private enlistmentServices: EnlistmentService, private evaluationService: EvaluationService,
    private route: ActivatedRoute) {
    this.vModelData = new Vendordata();
    this.stepno = this.route.snapshot.params.stepno;
    this.applicationref = this.route.snapshot.params.applicationrefno;
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;
          this.evaluationService.getVendorData(this.applicationref).subscribe(
            (data) => {
              this.vendorData = data;
              this.vModelData = this.vendorData;
              this.getVendorDocs();
              console.log(this.vModelData);

              debugger;
              if (this.vModelData.gstAddressArray.trim().length != 0 &&
                this.vModelData.gstRegArray.trim().length != 0 &&
                this.vModelData.gstStateArray.trim().length != 0) {

                var gstno = this.vModelData.gstRegArray.split(",");
                var gstaddress = this.vModelData.gstAddressArray.split(",");
                var gststate = this.vModelData.gstStateArray.split(",");

                for (var i = 0; i < gstno.length; i++) {
                  this.tiers.push(new Gst());
                }

                for (var i = 0; i < gstno.length; i++) {
                  this.tiers[i].dGstNo = gstno[i];
                  this.tiers[i].dGstAddress = gstaddress[i];
                  this.tiers[i].dGstState = gststate[i];
                }

              }
              else {
                //this.tiers[0] = { dGstNo: "", dGstAddress: "", dGstState: "" };
              }

            }
          )
        }
      }
    );
  }

  getVendorDocs() {
    let inputs = new FormData();
    inputs.append('applicationNumber', this.vModelData.applicationNumber);
    inputs.append('currentUserId', this.vModelData.userId);
    this.enlistmentServices.GetVendorDocs(inputs).subscribe(
      (data: any) => {
        this.vendorDocs = data;
        console.log(this.vendorDocs);
      }
    );
  }


  SubmitEnlistmentForm(form: NgForm) {

  }
}
